module.exports = __webpack_public_path__ + "static/img/tx.9f108ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tx.png
// module id = 282
// module chunks = 107